<template lang='pug'>
  .layout
    button#layout-filter
      span {{ $t('competitors_filters.layout') }}
      span#checked-layouts {{ formattedFilterLayout }}
    b-popover(ref="filter_popover" target='layout-filter' triggers='click blur' placement='bottomright')
      .layout-filter-list-wrapper
        ul.layout-filter-list(v-for='section in layouts')
          li(v-for='layout in section', :key='layout')
            input.layout-checkbox(
              type='checkbox' 
              :value='layout' 
              name='layout' 
              v-model='value' 
              @change='changedFilterValue(value)'
            )
            span {{ layout }}
      button.view-search-results(@click="viewSearchResults(value)") {{ $t('competitors_filters.view_search_results') }}
</template>

<script>
  import applyFilter from '@/mixins/apply-filter'
  import formatFilter from '@/mixins/formatted-filter'

  export default {
    mixins: [
      applyFilter,
      formatFilter
    ],

    props: {
      layout: {
        type: Array,
        default: () => ([])
      }
    },
    
    data() {
      return {
        value: this.layout
      }
    },

    computed: {
      layouts() {
        return [
          ['1R','1K','1DK','1LDK'],
          ['2K','2DK','2LDK'],
          ['3K','3DK','3LDK'],
          ['4K','4DK','4LDK~']
        ]
      },

      formattedFilterLayout() {
        if (this.value.length > 2) {
          return this.value.slice(0, 2).join(', ') + '...'
        } else {
          return this.value.join(', ')
        }
      }
    }
  }
</script>

<style lang='scss' scoped>
  @import '@/assets/css/mixins/competitors/filter.scss';

  .layout {
    #layout-filter {
      @include button-item-filter;

      #checked-layouts {
        @include span-checked-item;
      }
    }
  }

  .layout-filter-list-wrapper {
    @include item-filter-wrapper;

    .layout-filter-list {
      @include item-filter-ul;

      .layout-checkbox {
        @include item-checkbox;
      }
    }
  }

  .view-search-results {
    @include view-search-results;
  }
</style>
